<ng-container *ngIf="this.past_consultation_data.prescription.display">

  <p-dialog header="Prescription" *ngIf="this.past_consultation_data.prescription.display"
    [(visible)]="this.past_consultation_data.prescription.display" [modal]="true" [contentStyle]="{'overflow':'scroll'}"
    styleClass="p-dialog-width" [baseZIndex]="10000" [draggable]="false" id="prescription" [resizable]="false"
    (onHide)="this.past_consultation_data.prescription.display=false" [style]="{'width':'80%'}">

    <h4 *ngIf="this.past_consultation_data.prescription.posting">Fetching data...</h4>

    <p-progressSpinner [style]="{width: '50px', height: '50px'}"
      *ngIf="this.past_consultation_data.prescription.posting" strokeWidth="6">
    </p-progressSpinner>

    <div *ngIf="this.past_consultation_data.prescription.data.apiData.PromiseResult.success!=null && 
        this.past_consultation_data.prescription.data.apiData.PromiseResult.success==true">
      <div class="col-md-12">

        <ng-container *ngIf="this.past_consultation_data.prescription.data.apiData!=null && 
            this.past_consultation_data.prescription.data.data!=null && 
            this.past_consultation_data.prescription.data.data?.consultation?.p_prescriptions?.length > 0">
          <!-- <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text"></p-button> -->

          <app-prescription-details [data]="this.past_consultation_data.prescription.data.data"
            [dataId]='this.past_consultation_data.prescription.show'></app-prescription-details>


        </ng-container>
        <ng-container *ngIf="this.past_consultation_data.prescription.data.apiData!=null && 
                    (this.past_consultation_data.prescription.data.data==null || 
                    this.past_consultation_data.prescription.data.data?.consultation?.p_prescriptions?.length == 0)">
          <p>Prescription not available</p>
        </ng-container>

      </div>
    </div>

    <div class="col-md-12">
      <div *ngIf="(this.past_consultation_data.prescription.data.apiData.PromiseResult?.success!=null && 
            this.past_consultation_data.prescription.data.apiData.PromiseResult?.success==false) && 
            (this.past_consultation_data.prescription.data.apiData.PromiseResult?.error!=null)">
        <div class="alert alert-danger">
          {{this.past_consultation_data.prescription.data.apiData.PromiseResult?.error.message}}</div>
      </div>
      <div *ngIf="(this.past_consultation_data.prescription.data.apiData.PromiseResult?.success!=null && 
            this.past_consultation_data.prescription.data.apiData.PromiseResult?.success==false) && 
            (this.past_consultation_data.prescription.data.apiData.ServerError?.error!=null && 
            this.past_consultation_data.prescription.data.apiData.ServerError?.statusCode!=500)">
        <div class="alert alert-danger"
          *ngFor="let message of this.past_consultation_data.prescription.data.apiData.ServerError?.message">
          {{message}}
        </div>
      </div>
      <div
        *ngIf="(this.past_consultation_data.prescription.data.apiData.PromiseResult?.success!=null && this.past_consultation_data.prescription.data.apiData.PromiseResult?.success==false) && (this.past_consultation_data.prescription.data.apiData.ServerError?.error!=null && this.past_consultation_data.prescription.data.apiData.ServerError?.statusCode==500)">
        <div class="alert alert-danger">
          {{this.past_consultation_data.prescription.data.apiData.ServerError?.message}}
        </div>
      </div>
    </div>
  </p-dialog>
  <div *ngIf="this.past_consultation_data.prescription.data.data!=null &&
            this.past_consultation_data.prescription.data.apiData.PromiseResult.success!=null && 
            this.past_consultation_data.prescription.data.apiData.PromiseResult.success==true">
    <app-prescription-details *ngIf="this.past_consultation_data.prescription.display"
      [data]="this.past_consultation_data.prescription.data.data"
      [dataId]='this.past_consultation_data.prescription.printcontent'>
    </app-prescription-details>
  </div>

</ng-container>



<ng-container *ngIf="this.past_consultation_data.reports.display">


  <p-dialog header="Report" *ngIf="this.past_consultation_data.reports.display"
    [(visible)]="this.past_consultation_data.reports.display" [modal]="true" [contentStyle]="{'overflow':'scroll'}"
    [style]="{width: '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="this.past_consultation_data.reports.display=false">
    <h4 *ngIf="this.past_consultation_data.reports.posting">Fetching data...</h4>
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="this.past_consultation_data.reports.posting"
      strokeWidth="6"></p-progressSpinner>
    <div *ngIf="this.past_consultation_data.reports.data.apiData.PromiseResult.success!=null && 
            this.past_consultation_data.reports.data.apiData.PromiseResult.success==true">

      <div class="spaces"></div>

      <app-doctorreportpdf [data]='this.past_consultation_data.reports.data.data'
        [dataId]='this.past_consultation_data.reports.show'></app-doctorreportpdf>

      <!-- <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text"></p-button> -->

    </div>

    <div class="col-md-12">
      <div *ngIf="(this.past_consultation_data.reports.data.apiData.PromiseResult?.success!=null && 
                this.past_consultation_data.reports.data.apiData.PromiseResult?.success==false) && 
                (this.past_consultation_data.reports.data.apiData.PromiseResult?.error!=null)">
        <div class="alert alert-danger">
          {{this.past_consultation_data.reports.data.apiData.PromiseResult?.error.message}}</div>
      </div>
      <div *ngIf="(this.past_consultation_data.reports.data.apiData.PromiseResult?.success!=null && 
                this.past_consultation_data.reports.data.apiData.PromiseResult?.success==false) && 
                (this.past_consultation_data.reports.data.apiData.ServerError?.error!=null && 
                this.past_consultation_data.reports.data.apiData.ServerError?.statusCode!=500)">
        <div class="alert alert-danger"
          *ngFor="let message of this.past_consultation_data.reports.data.apiData.ServerError?.message">
          {{message}}
        </div>
      </div>
      <div *ngIf="(this.past_consultation_data.reports.data.apiData.PromiseResult?.success!=null && 
                this.past_consultation_data.reports.data.apiData.PromiseResult?.success==false) && 
                (this.past_consultation_data.reports.data.apiData.ServerError?.error!=null && 
                this.past_consultation_data.reports.data.apiData.ServerError?.statusCode==500)">
        <div class="alert alert-danger">
          {{this.past_consultation_data.reports.data.apiData.ServerError?.message}}
        </div>
      </div>
    </div>

  </p-dialog>

  <div *ngIf="this.past_consultation_data.reports.data.data!=null &&
            this.past_consultation_data.reports.data.apiData.PromiseResult.success!=null && 
            this.past_consultation_data.reports.data.apiData.PromiseResult.success==true">

    <div class="spaces"></div>

    <app-doctorreportpdf [data]='this.past_consultation_data.reports.data.data'
      [dataId]='this.past_consultation_data.reports.printcontent'></app-doctorreportpdf>

  </div>

</ng-container>


<app-loading type='LOADING_DATA' *ngIf="this.past_consultation_data.past_consultation.data.apiData.Posting"></app-loading>
<div class="ui-g" *ngIf="!this.past_consultation_data.past_consultation.data.apiData.Posting">

  <div class="ui-g-12">
    <h2 class="boldnlabel">eGlobalDoctors Consultations</h2>
    <div class="ui-g">
      <div class="ui-g-12">
        <p-table #dt1 [value]="this.past_consultation_data.past_consultation.data.consultation_data" dataKey="id"
          styleClass="p-datatable-customers" [rows]="10" [paginator]="true" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="[ 
                            'consultation_date',
                        'specialty_name',
                        'priority_type',
                        'priority_type',
                        'doctor_name']">

          <ng-template pTemplate="caption">
            <div class="table-header">
              <span class="p-input-icon-left table-search-span">
                <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                  placeholder="Search" class="table-search" />
              </span>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th style="width: 10%;" pSortableColumn="sr_no"><b>Sr. No.</b>
                <p-sortIcon field="sr_no"></p-sortIcon>
              </th>
              <th style="width: 15%;" pSortableColumn="consultation_date"><b>Consultation Date</b>
                <p-sortIcon field="consultation_date"></p-sortIcon>
              </th>
              <th style="width: 22.5%;" pSortableColumn="specialty_name"><b>Specialty</b>
                <p-sortIcon field="specialty_name"></p-sortIcon>
              </th>
              <!-- <th pSortableColumn="priority_type" style="width: 100px;"><b>Priority</b>
                        <p-sortIcon field="priority_type"></p-sortIcon>
                    </th> -->
              <th style="width: 22.5%;" pSortableColumn="doctor_name"><b>Doctor</b>
                <p-sortIcon field="doctor_name"></p-sortIcon>
              </th>
              <th style="width: 15%;"><b>Doctor Report </b></th>
              <th style="width: 15%;"><b>Prescription</b></th>


            </tr>


          </ng-template>

          <ng-template pTemplate="body" let-consultation>
            <tr [pSelectableRow]="consultation">
              <td style="width: 10%;">
                {{consultation.sr_no+1}}
              </td>
              <td style="width: 15%;" class="notranslate">

                <span *ngIf="consultation.consultation_date != null;else nodate">{{consultation.consultation_date | date}}</span>
                <ng-template #nodate>
                  <span>N/A</span>
                </ng-template>
              </td>
              <td style="width: 22.5%;" class="notranslate">
                <span *ngFor="let sp of consultation.specialty_name">
                  <p-message severity="success" text="{{sp}}"></p-message>
                </span>
              </td>
              <!-- <td style="width: 100px;">
                        <span>{{consultation.priority_type}}</span>
                    </td> -->
              <td style="width: 22.5%;" class="notranslate">
                <span *ngFor="let sp of consultation.doctor_name">
                  <p-message severity="success" text="{{sp}}"></p-message>
                </span>
              </td>
              <td style="width: 15%;">
                <ng-container *ngIf='consultation.consultation_status=="CLOSED"'>
                  <span>
                    <p-button (click)=" this.Report(consultation.consultation_id)" icon="pi pi-external-link"
                      label="View"></p-button>
                  </span>
                </ng-container>
                <ng-container *ngIf='consultation.consultation_status!="CLOSED"'>
                  N/A
                </ng-container>
              </td>
              <td style="width: 15%;">
                <ng-container *ngIf='consultation.consultation_status=="CLOSED"'>
                  <span>
                    <p-button (click)="this.Prescription(consultation.consultation_id)" icon="pi pi-external-link"
                      label="View">
                    </p-button>
                  </span>
                </ng-container>
                <ng-container *ngIf='consultation.consultation_status!="CLOSED"'>
                  N/A
                </ng-container>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">No Data found.</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">
          </ng-template>
          <ng-template pTemplate="paginatorright">
          </ng-template>
        </p-table>

      </div>
    </div>
  </div>

</div>

<app-error-messages [api_result]="this.past_consultation_data.past_consultation.data.apiData"></app-error-messages>